export default "__VITE_ASSET__DD0WoGLq__"